import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: 'SOP业务流程',
    type: 'BF_1',
}
